/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 17:37:33
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/AdvancedFrequencyDiscount/index.tsx
 */
import React from 'react';
import { Form, OriCheckbox } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
//import css from './css.module.less';
const Item = Form.Item;
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const AFD = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { disableEdit } = props;
  return (
    <SectionWrapper
      style={{ paddingBottom: 32 }}
      title={getI18n(
        'salesChannelSubscriptionBuy.afd.advancedFrequencyDiscount',
      )}>
      <Item name={'applyToDifferentDiscount'} valuePropName={'checked'}>
        <OriCheckbox disabled={disableEdit}>
          {getI18n('salesChannelSubscriptionBuy.afd.afdTip')}
        </OriCheckbox>
      </Item>
    </SectionWrapper>
  );
};
export default AFD;
